import React from 'react';
import { Typography } from 'antd';

const { Text } = Typography;

interface DateSeparatorProps {
  date: string;
}

const DateSeparator: React.FC<DateSeparatorProps> = ({ date }) => {
  return (
    <div className="date-separator">
      <div className="date-separator-line"></div>
      <Text className="date-separator-text">{date}</Text>
      <div className="date-separator-line"></div>
    </div>
  );
};

export default DateSeparator;
